// Added for Checkmark in checkbox (which is different than CheckMark.tsx in general-interface-2)
// This one has rounded corners and is 16x16

import * as React from "react";

function SvgCheckMarkRounded(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.31476 11.8585L3.13295 8.4415C2.95568 8.2535 2.95568 7.9475 3.13295 7.7575L3.77568 7.0745C3.95295 6.8865 4.24113 6.8865 4.4184 7.0745L6.63657 9.4665L11.5811 4.1415C11.7584 3.9535 12.0465 3.9535 12.2238 4.1415L12.8665 4.8255C13.0438 5.0135 13.0438 5.3205 12.8665 5.5075L6.95748 11.8585C6.78021 12.0465 6.49203 12.0465 6.31476 11.8585Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgCheckMarkRounded;
